export const ContentType = {
  WEBTOON: '웹툰',
  ILLUSTRATION: '일러스트',
  TEXT: '글',
} as const;

export type ContentType = keyof typeof ContentType;
